import type { SystemStyleObject } from '@chakra-ui/system';
import { Fragment } from 'react';

import { Mark } from './Mark';
import type { HighlightChunk } from './types';
import { useHighlight } from './useHighlight';

export type HighlightProps = {
  query: string | string[];
  children: string | ((props: HighlightChunk[]) => React.ReactNode);
  styles?: SystemStyleObject;
};

/**
 * `Highlight` allows you to highlight substrings of a text.
 *
 * @see Docs https://chakra-ui.com/docs/components/highlight
 */
export const Highlight = ({
  children,
  query,
  styles,
}: HighlightProps): JSX.Element => {
  if (typeof children !== 'string') {
    throw new Error('The children prop of Highlight must be a string');
  }

  const chunks = useHighlight({ query, text: children });

  return (
    <>
      {chunks.map((chunk, index) => {
        return chunk.match ? (
          // eslint-disable-next-line react/no-array-index-key
          <Mark key={index} sx={styles}>
            {chunk.text}
          </Mark>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>{chunk.text}</Fragment>
        );
      })}
    </>
  );
};
